import { ReactNode } from "react";
import { HTTP_MESSAGES } from "src/shared/config";
import { IRequestData, IMiddleware } from "../types";
import { setAlert } from "src/shared/utils/alert";

type GetMessageFromStatusCode = (
  statusCode: number,
  statusMessageConfig?: {
    [errorCode: number]: string | ReactNode;
  }
) => string;

class AlertMiddleware implements IMiddleware {
  private pageUrl;

  getRequestData(): void {
    this.pageUrl = window.location.href;
  }

  getResponseData({ statusMessageConfig }: IRequestData, response: Response): void {
    if (statusMessageConfig && (statusMessageConfig[response?.status] || statusMessageConfig[2])) {
      setAlert("success", this.getMessageFromStatusCode(response?.status || 2, statusMessageConfig));
    }
  }

  getErrorData({ statusMessageConfig }: IRequestData, error: Response | TypeError): void {
    // Don't show alert if user has switched to some other page
    if (window.location.href !== this.pageUrl) return;
    // Don't show toast for 401 — Client.handleError already redirects to login
    if (!(error instanceof TypeError) && error.status === 401) return;
    if (error instanceof TypeError) {
      setAlert("error", this.getMessageFromStatusCode(5, statusMessageConfig));
    } else {
      setAlert("error", this.getMessageFromStatusCode(error.status, statusMessageConfig));
    }
  }

  getMessageFromStatusCode: GetMessageFromStatusCode = (statusCode, statusMessageConfig = {}) => {
    return (
      statusMessageConfig[statusCode] ||
      statusMessageConfig[Math.floor(statusCode / 100)] ||
      HTTP_MESSAGES[statusCode] ||
      HTTP_MESSAGES[Math.floor(statusCode / 100)] ||
      HTTP_MESSAGES[5]
    );
  };
}

export default AlertMiddleware;
